"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TableItem = /** @class */ (function () {
    function TableItem() {
        // tslint:disable-next-line
        this.valueOfColumn = new Map();
        this.valueOfCustomColumn = new Map();
    }
    TableItem.prototype.clone = function () {
        var item = new TableItem();
        item.valueOfColumn = this.copyMap(this.valueOfColumn);
        item.valueOfCustomColumn = this.copyMap(this.valueOfCustomColumn);
        item.entityInstanceId = this.entityInstanceId;
        item.entitySearchItem = this.entitySearchItem;
        return item;
    };
    TableItem.prototype.copyMap = function (map) {
        var newMap = new Map();
        for (var _i = 0, _a = Array.from(map.keys()); _i < _a.length; _i++) {
            var key = _a[_i];
            newMap.set(key, map.get(key));
        }
        return newMap;
    };
    TableItem.prototype.toObj = function () {
        var obj = {};
        this.valueOfColumn.forEach(function (value, key) {
            obj[key] = value;
        });
        return obj;
    };
    return TableItem;
}());
exports.TableItem = TableItem;
//# sourceMappingURL=table-item.js.map